export const dashHome = {
  index: {
    boxes: {
      reservas: "Réservations",
      checkins: "Check-ins",
      ocupacion: "Occupation",
      facturacion: "Revenus",
      ingresosTotal: "Revenus totaux",
      saldos: "Soldes en attente",
      solicitudes: "Demandes IA",
      facturas: "Factures en attente",
      acciones: "Actions en attente",
      salen: "Départs aujourd'hui",
      llegadas: "Arrivées à venir",
      ingresosDesglose: "Détail des revenus",
    },
    editToolbar: {
      done: "Terminé",
      addBox: "Ajouter un bloc",
      reset: "Réinitialiser",
      hint: "Glissez pour déplacer · tirez le coin pour redimensionner",
      allBoxesVisible: "Tous les blocs sont visibles.",
      removeTitle: "Retirer",
      showOnboarding: "Afficher l'avis de configuration",
    },
  },
  arrivals: {
    viewAll: "Voir toutes les arrivées",
  },
  todayLeaving: {
    title: "Clients partant aujourd'hui",
    subtitle: "Départs prévus aujourd'hui.",
    empty: "Aucun client ne part aujourd'hui.",
    loading: "Chargement des départs du jour…",
    balance: "Solde",
    balanceDueTitle: "Solde dû : {amount} {currency}",
    paid: "Payé",
    paidTitle: "Réservation payée",
    viewAll: "Voir tous les départs",
  },
  mobileNotice: {
    sheetAriaLabel: "Télécharger l'application WACheckin",
    closeAriaLabel: "Fermer",
    title: "Profitez pleinement de WACheckin",
    desc: "Le panneau est conçu pour <b>ordinateur</b>. Sur mobile, vous obtenez un résumé ; pour gérer <b>toutes les fonctionnalités</b> confortablement, ouvrez-le sur votre ordinateur ou téléchargez notre <b>application</b>.",
    appStorePrefix: "Télécharger dans l'",
    googlePlayPrefix: "Disponible sur",
    continueOnMobile: "Continuer sur mobile",
  },
};